module.exports = __webpack_public_path__ + "img/icon10.23901b33.png";